import { render } from "./Navbar.vue?vue&type=template&id=08bdeb04"
import script from "./Navbar.vue?vue&type=script&lang=ts"
export * from "./Navbar.vue?vue&type=script&lang=ts"

import "./Navbar.vue?vue&type=style&index=0&id=08bdeb04&lang=css"
script.render = render

export default script